import React from 'react';
import { IdentityTypeEnum } from '../../models/onboarding.model';

interface RadioOption {
  label: string;
  value: any;
}

interface BaseRadioGroupNewProps {
  label?: string;
  required?: boolean;
  name: string;
  options: RadioOption[];
  value?: any;
  onChange: (value: string) => void;
  className?: string;
}

const BaseRadioGroupNew: React.FC<BaseRadioGroupNewProps> = ({
  label,
  required,
  name,
  options,
  value,
  onChange,
  className = '',
}) => {
  const handleChange = (value: string) => {
    onChange(value);
  };

  return (
    <div className={className}>
      <div className="mb-1 flex items-center gap-2">
        <p className="font-semibold text-xs">{label}</p>
        <p className={`text-red-500 ${required ? '' : 'invisible'}`}>*</p>
      </div>
      <div className="flex space-x-4">
        {options.map((option) => (
          <label
            key={option.value}
            className="flex items-center space-x-2 cursor-pointer text-sm"
          >
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={value === option.value}
              onChange={() => handleChange(option.value)}
              className="accent-blue-500"
            />
            <span>{option.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default BaseRadioGroupNew;
